module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/IECQ符合性证书.3d01c569.png";